(() => {
  const header = document.querySelector('[data-mmol-chrome-header]');
  const toggle = header?.querySelector('[data-mmol-chrome-menu-toggle]');
  const menu = document.querySelector('[data-mmol-chrome-mobile-menu]');
  if (!header || !toggle || !menu || header.dataset.mmolChromeInitialized) return;
  header.dataset.mmolChromeInitialized = 'true';
  const desktop = matchMedia('(min-width:821px)');
  const root = document.documentElement;
  let open = false;
  let frame = 0;
  let focusFrame = 0;
  let inertElements = [];
  let wasScrollLocked = false;
  const menuLinks = () => [...menu.querySelectorAll('a[href]')];
  const focusableControls = () => [...header.querySelectorAll('a[href],button:not([disabled])'), ...menuLinks()].filter(element => element.getClientRects().length && element.tabIndex >= 0);
  const focusMenu = () => menuLinks()[0]?.focus();
  function updateGeometry() {
    frame = 0;
    const rect = header.getBoundingClientRect();
    const height = Math.round(rect.height);
    document.body.style.setProperty('--header-height', `${height}px`);
    document.body.style.setProperty('--header-group-height', `${height}px`);
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    menu.style.setProperty('--mmol-chrome-menu-top', `${Math.max(0, rect.bottom)}px`);
    header.classList.toggle('mmol-chrome-scrolled', scrollY > 16);
  }
  function queueGeometry() {
    if (!frame) frame = requestAnimationFrame(updateGeometry);
  }
  function setOpen(next, restoreFocus = true) {
    if (next === open) return;
    open = next;
    cancelAnimationFrame(focusFrame);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    menu.hidden = !open;
    menu.inert = !open;
    if (open) {
      wasScrollLocked = root.classList.contains('mmol-chrome-menu-open');
      root.classList.add('mmol-chrome-menu-open');
      inertElements = [...document.body.children].filter(element => !element.contains(header) && !element.contains(menu) && !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName)).map(element => ({ element, wasInert: element.inert }));
      inertElements.forEach(({ element }) => { element.inert = true; });
      updateGeometry();
      focusFrame = requestAnimationFrame(() => { if (open) focusMenu(); });
    } else {
      if (!wasScrollLocked) root.classList.remove('mmol-chrome-menu-open');
      inertElements.forEach(({ element, wasInert }) => { element.inert = wasInert; });
      inertElements = [];
      if (restoreFocus && toggle.getClientRects().length) toggle.focus();
    }
  }
  toggle.addEventListener('click', () => setOpen(!open));
  menu.addEventListener('click', event => { if (event.target.closest('a[href]')) setOpen(false, false); });
  document.addEventListener('keydown', event => {
    if (!open) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Tab') {
      const controls = focusableControls();
      const first = controls[0];
      const last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
  });
  document.addEventListener('focusin', event => {
    if (open && !header.contains(event.target) && !menu.contains(event.target)) focusMenu();
  });
  desktop.addEventListener('change', event => {
    if (event.matches && open) {
      const focusWasInMenu = menu.contains(document.activeElement) || document.activeElement === toggle;
      setOpen(false, false);
      if (focusWasInMenu) header.querySelector('.mmol-chrome-home')?.focus();
    }
    queueGeometry();
  });
  addEventListener('scroll', queueGeometry, { passive: true });
  addEventListener('resize', queueGeometry, { passive: true });
  addEventListener('pagehide', () => { if (open) setOpen(false, false); });
  if ('ResizeObserver' in window) new ResizeObserver(queueGeometry).observe(header);
  updateGeometry();
})();
